import '../styles/components/progress.css';

function formatDuration(secs) {
  const h = Math.floor(secs / 3600);
  const m = Math.floor((secs % 3600) / 60);
  const s = secs % 60;
  if (h > 0) return `${h}h ${m}m`;
  if (m > 0) return `${m}m ${s}s`;
  return `${s}s`;
}

export default function ProgressBar({ job, currentRow }) {
  const progress = job.progress;
  const processed = progress?.processed || 0;
  const total = progress?.total || 0;
  const finished = job.status === 'completed' || job.status === 'failed';
  const running = job.status === 'running';

  let elapsed = '';
  let elapsedSecs = 0;
  if (job.started_at) {
    const start = new Date(job.started_at);
    const end = finished && job.completed_at ? new Date(job.completed_at) : new Date();
    elapsedSecs = Math.floor((end - start) / 1000);
    elapsed = formatDuration(elapsedSecs);
  }

  const estimatedMax = job.estimated_cost?.time_max_seconds || 0;
  const timePct = running && estimatedMax > 0 ? Math.min(99, Math.round((elapsedSecs / estimatedMax) * 100)) : 0;
  const pct = finished ? 100 : timePct;


  return (
    <div className="progress-bar-container">
      <div className="progress-bar-header">
        <span>
          {job.status === 'pending' ? 'Queued...' : finished ? (total > 0 ? 'Complete' : 'No row data') : 'Processing...'}
          {currentRow && !finished && (
            <span style={{ color: 'var(--text3)', fontWeight: 400, marginLeft: 8 }}>
              — {currentRow.name ? `${currentRow.name} ` : ''}#{currentRow.row_index}
            </span>
          )}
        </span>
        <span className="progress-bar-pct">{pct}%</span>
      </div>
      <div className="progress-bar-track">
        <div
          className={`progress-bar-fill${finished ? ' finished' : ''}`}
          style={{ width: `${pct}%` }}
        />
      </div>
      <div className="progress-bar-details">
        {elapsed && <span>Duration: {elapsed}</span>}
        {!finished && job.estimated_cost?.time_display && (
          <span>Est. time: {job.estimated_cost.time_display}</span>
        )}
        {job.estimated_cost && (
          <span>Est. cost: {job.estimated_cost.cost_display}</span>
        )}
      </div>
    </div>
  );
}
